/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * Brands Web API v2
 * OpenAPI spec version: v2
 */

export type TwoFactorAuthDetailsSchemaMinMfaLevel = typeof TwoFactorAuthDetailsSchemaMinMfaLevel[keyof typeof TwoFactorAuthDetailsSchemaMinMfaLevel];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TwoFactorAuthDetailsSchemaMinMfaLevel = {
  None: 0,
  Email: 1,
  Phone: 2,
  Authenticator: 3,
} as const;
